import React,{useState,useEffect} from 'react'
import clinicService from '../../../services/clinic.service'
import templateService from '../../../services/template.service'
import {toast} from 'react-toastify'
import { useNavigate, Link } from 'react-router-dom'

const TemplateListItem = ({item})=>{
    const navigate = useNavigate()
    function toProperCase(inputString) {
        // Split the string into words based on underscores
        let words = inputString.split('_');
    
        // Capitalize the first letter of each word and join them back
        let properCaseString = words.map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
    
        return properCaseString;
    }
    const handleClick = (id)=>{
        navigate(`/sms-template/edit/${item.clinicId}/${id}`);
    }
    return (
      <>
       <li className="list-group-item d-flex justify-content-between align-items-center">
                <div className="">
                    <div className="h5">{toProperCase(item.type)}</div>
                   <span className=""><small>Status  : {item.status === 1? "Active":"Inactive"}</small></span>
                </div>
                <div>
                   <button className="btn btn-sm btn-secondary" onClick={()=>handleClick(item.id)}><i className="bi bi-pencil-square"></i> Edit</button>
                  
                </div>
                
              </li>
      </>
    )
  }
function ClinicSmsTemplate() {
    const [allClinics,setAllClinics] = useState([])
    const [isClinicData,setIsClinicData] = useState(false)
    const [templateList,setTemplateList] = useState([])
    const [currentClinic,setCurrentClinic] = useState()

    useEffect(()=>{
        getAllClinics()
    },[])

    const getAllClinics = ()=>{
        clinicService.getAllClinicsFast()
        .then(res=>{
            setAllClinics(res.data)
        })
        .catch(err=>{
            console.log("Error Getting Clinic List")
            console.log(err)
        })
    }

    const getClinicSmsTemplate = (clinicid)=>{
        //get clinic email templates
        setTemplateList([])
        templateService.getSmsTemplate(clinicid)
        .then(res=>{
           
            setIsClinicData(true)
            console.log(res.data)
            setTemplateList(res.data)
        })
        .catch(err=>{
             if(err.response.status === 404){
                setTemplateList([])
                console.log(err.response.data.error)
                toast.error(err.response.data.error,{
                    position:toast.POSITION.BOTTOM_RIGHT
                })
            }else{
                console.log(err)
            }
           


        })
    }
    const onSelectChange = (selectedValue)=>{
        console.log("Select item changed : "+selectedValue)
        setCurrentClinic(selectedValue)
        getClinicSmsTemplate(selectedValue)

    }
    return (
   <div className="card">
    <div className="card-body">
        
        <h5 className="card-title">Clinic Sms templates</h5>
        
       <div className="form-group">
            <label htmlFor="" className="form-label">Select Clinic</label>
            <select name="" id="" onChange={e=>onSelectChange(e.target.value)} className='form-select'>
                {allClinics && allClinics.map((clinic)=>{
                    return <option key={clinic.id} value={clinic.id}>{clinic.name}</option>
                })}
            </select>
       </div>
       {currentClinic && currentClinic >=1 ? <>
            <div className="mt-3">
                <div className="d-flex align-item-center justify-content-end">
                    <Link to={"load/"+currentClinic+"/sms"} className="btn btn-sm btn-info"><i className="bi bi-box-arrow-in-right"></i> Assign Template to Clinic</Link>
                </div>
            </div>
        </> :""}
        {isClinicData ?
       <div className="mt-5">
               
                <ul className="list-group mt-3">
                    {
                        templateList && templateList.map(item=>{
                        //console.log(item)
                        return <TemplateListItem  key={item.id} item={item}/>
                        })
                    }
                        
                        
                    </ul>
       </div>
       : ""}
    </div>
   </div>
  )
}

export default ClinicSmsTemplate